import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as RouteConstants from '../../constants/route.constants';
import { Observable, retry } from 'rxjs';
import { InsertMecsCountryDataModel } from 'src/app/models/mecs-models/insert-mecs-country-data.model';
import { GetMecsCountryDataInformationModel, GetMecsCountryDataModel } from 'src/app/models/mecs-models/get-mecs-country-data.model';

@Injectable({
  providedIn: 'root',
})
export class MecsCountryDataService {
  private routeConstants = RouteConstants;

  constructor(private httpClient: HttpClient) {}

  addMecsCountryData(
    insertMecsCountryData: InsertMecsCountryDataModel
  ): Observable<GetMecsCountryDataModel[]> {
    return this.httpClient.post<any>(
      this.routeConstants.ADD_MECS_COUNTRY_DATA,
      insertMecsCountryData
    );
  }

  getMecsCountryDataByCountryId(
    countryId: number
  ): Observable<GetMecsCountryDataInformationModel> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('countryId', countryId);

    return this.httpClient.get<GetMecsCountryDataInformationModel>(
      this.routeConstants.GET_MECS_COUNTRY_DATA_BY_ID,
      { params: queryParams }
    );
  }

  getMecsCountryContactDetailsByCountryId(
    countryId: number
  ): Observable<GetMecsCountryDataModel[]> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('countryId', countryId);

    return this.httpClient.get<GetMecsCountryDataModel[]>(
      this.routeConstants.GET_MECS_COUNTRY_CONTACTS_BY_ID,
      { params: queryParams }
    );
  }
}
